import React from "react";

type CollapsibleDescriptionCardProps = {
  title: string;
  description: string;
  collapseAt?: number;
};

export function CollapsibleDescriptionCard({
  title,
  description,
  collapseAt = 280,
}: CollapsibleDescriptionCardProps): JSX.Element | null {
  const trimmed = description.trim();
  const [expanded, setExpanded] = React.useState<boolean>(false);

  React.useEffect(() => {
    setExpanded(false);
  }, [trimmed]);

  if (trimmed === "") {
    return null;
  }

  const shouldShowToggle = trimmed.length > collapseAt;
  const isCollapsed = shouldShowToggle && !expanded;

  return (
    <section className="report-card company-description-card">
      <h3>{title}</h3>
      <div className={`company-description-body ${isCollapsed ? "is-collapsed" : ""}`}>
        <p className={`company-description-text ${isCollapsed ? "is-collapsed" : ""}`}>{trimmed}</p>
      </div>
      {shouldShowToggle && (
        <button
          type="button"
          className="company-description-toggle"
          onClick={() => setExpanded((previous) => !previous)}
        >
          {expanded ? "Show less" : "Show more"}
        </button>
      )}
    </section>
  );
}
